var React = require('react');

function SocialNetworksIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#5ww1ntr3ca)","key":0},React.createElement("path",{"d":"M21.41 13.183c-.454.098-.925.15-1.41.15a6.642 6.642 0 0 1-4.479-1.728l-5.33 5.332a5.555 5.555 0 1 1-1.571-1.571l5.519-5.52a6.666 6.666 0 1 1 9.335 2.512l3.744 9.36a9.445 9.445 0 1 1-1.98 1.033l-3.828-9.566v-.002zM5.555 23.333a3.334 3.334 0 1 0 0-6.667 3.334 3.334 0 0 0 0 6.667zM20 11.111a4.445 4.445 0 1 0 0-8.889 4.445 4.445 0 0 0 0 8.888zm10.555 26.666a7.222 7.222 0 1 0 .19-14.443 7.222 7.222 0 0 0-.19 14.443z","fill":"#fff"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"5ww1ntr3ca"},React.createElement("path",{"fill":"#fff","d":"M0 0h40v40H0z"})))]);
}

SocialNetworksIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = SocialNetworksIcon;

SocialNetworksIcon.default = SocialNetworksIcon;
